import { t } from '../../../../i18n'
import type { TeamHistoryTerms } from '../types'

/**
 * The translated nouns for team-history labels. `common:competition` is
 * overridden per tenant (Canlan's bundle reads "season"), so the counts follow
 * the tenant without a branch here.
 *
 * i18next v25 does not map `count` onto the legacy `_plural` keys, so both
 * forms are read explicitly and `countLabel` picks between them.
 */
export const getTeamHistoryTerms = (): TeamHistoryTerms => ({
  competition: {
    singular: t('common:competition', {}),
    plural: t('common:competition_plural', {}),
  },
  player: {
    singular: t('common:player', {}),
    plural: t('common:player_plural', {}),
  },
})
